export default {
    title: 'New Order',
    discription: 'Please visit this page on desktop to place an order.',
    helper: 'Oops!',
    button: 'Go to dashboard'
  };
  